import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useCustomerData } from "@cinch-labs/customer-data-segment";
import styles from "./spring-sale-promo-banner.module.css";
export function SpringSalePromoBanner(param) {
    var sendDigitalDataEvent = param.sendDigitalDataEvent;
    var trackEvent = useCustomerData().trackEvent;
    var handleOnClick = function(value) {
        var data = {
            event: {
                name: "click",
                category: "promotions",
                action: "banner",
                label: "spring sale 2023",
                value: value
            }
        };
        trackEvent({
            type: "track",
            eventName: "Promotion Clicked",
            data: data
        });
        if (sendDigitalDataEvent) sendDigitalDataEvent(data);
    };
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx("span", {
                className: styles.saveTag,
                children: "SAVE"
            }),
            /*#__PURE__*/ _jsxs("p", {
                className: styles.text,
                children: [
                    "Up to \xa32000 off",
                    " ",
                    /*#__PURE__*/ _jsx("a", {
                        href: "/find-vehicle?tags=cars-on-offer",
                        onClick: function() {
                            return handleOnClick("selected EV");
                        },
                        children: "selected EVs"
                    }),
                    " ",
                    "plus \xa3500 charging on us with cinchCharge. Ends 4pm 20/03, T&Cs apply.",
                    " ",
                    /*#__PURE__*/ _jsx("a", {
                        href: "/offers",
                        onClick: function() {
                            return handleOnClick("find out more");
                        },
                        children: "Find out more"
                    })
                ]
            })
        ]
    });
}
export default SpringSalePromoBanner;
